import { Link, useHistory, useParams } from "react-router-dom";
import "./ELlandingStyle.css";
import { Paths } from "../../routes/routePaths";
import { ProgressBar, Step } from "react-step-progress-bar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authServices, generateOtp, validateOtp, isNewUser, generateLoginOtp, validateLoginOtp, verifyAccessCode } from "../../../Services/Auth";
import { emailExist } from "../../../Actions/AuthAction";
import axios from "axios";
import { Icon, Button, Form, Modal } from "semantic-ui-react";
import { showNotification } from "../../../Actions/componentActions";
import EntrepreneurTabs from "../EntrepreneurTabs";
import { getYearList } from "../../../Utilityfunctions/YearOptions";

function TextInput({
  label = '',
  type = "text",
  placeholder = '',
  error,
  className = '',
  wrapperClassName = '',
  autoComplete = '',
  showEyeIcon = false,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`m-0 ${wrapperClassName}`}>
      <label className={`block ${error ? "text-red-500" : "text-gray-700"} text-md mb-1`}>
        {label}
      </label>
      <div className="relative">
        <input
          type={showEyeIcon && showPassword ? "text" : type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className={`w-full px-4 py-3 sm:py-4 md:py-5 border ${error ? "border-red-500" : "border-gray-300"
            } bg-[#F3F8FD] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0054a6] text-gray-800 ${className}`}
          {...props}
        />
        {showEyeIcon && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 m-0 focus:outline-none"
          >
            {showPassword ? (
              <Icon name='eye slash' className="h-6 w-6 m-0" />
            ) : (
              <Icon name='eye' className="h-6 w-6 m-0" />
            )}
          </button>
        )}
      </div>
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}


function SelectInput({ label, options = [], error, ...props }) {
  return (
    <div className="m-0">
      <label className={`block ${error ? "text-red-500" : "text-gray-700"} text-md mb-1`}>{label}</label>
      <select
        className={`w-full px-4 !py-4 border ${error ? "border-red-500" : "border-gray-300"} bg-[#F3F8FD] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0054a6] text-gray-800`}
        {...props}
      >
        <option value="">Select</option>
        {options.map((opt, index) => (
          <option key={index} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      {/* {error && <p className="text-red-500 text-xs mt-1">{error}</p>} */}
    </div>
  );
}

function PrimaryButton({ children, ...props }) {
  return (
    <button
      style={{ backgroundColor: "#0054A6" }}
      className="hover:opacity-90 w-full mt-6 new-font-display font-bold flex justify-center gap-3 items-center text-white px-8 py-4 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
      {...props}
    >
      {children}
    </button>
  );
}

const Yearofbirthoption = getYearList;

function ProgressStepper({ step, totalSteps }) {
  return (
    <ProgressBar filledBackground="#0054A6" width={step >= 3 ? '35%' : ''} percent={((step - 1) / (totalSteps - 1)) * 100}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <Step key={i} transition="scale">
          {({ accomplished }) => (
            <div
              className={`h-8 w-8 flex items-center justify-center rounded-full border border-[#0054A6] ${accomplished ? "!bg-[#0054A6] text-white" : "text-gray-700"
                }`}
            >
              {i + 1}
            </div>
          )}
        </Step>
      ))}
    </ProgressBar>
  );
}

function Login() {
  const history = useHistory();
  const [errors, setErrors] = useState({})
  const basePath = window.location.href.toLowerCase().includes("creighton") ? '/creighton' : '/entrepreneur';

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    let data = Object.fromEntries(formData)
    data.rememberMe = data?.rememberMe === 'on'

    authServices.userLogin(data).then((data) => {
      if (data?.status === 200) {
        axios.defaults.headers.common['Authorization'] = `${data?.data?.token}`;
        sessionStorage.setItem("ssoToken", data?.data?.token);
        history.push(`${basePath}/introduction`)
      } else {
        setErrors({ message: data?.message })
      }
    })
  }

  const handleChange = (e) => {
    const { name } = e.target;
    setErrors(prev => ({
      ...prev,
      [name]: "",
      message: ''
    }));
  }
  return (
    <div className="bg-white shadow-[0px_1px_10px_2px_rgba(0,0,0,0.25)] rounded-2xl p-8 md:px-12 md:py-10 w-full flex flex-col gap-9 !pb-[5rem] border border-gray-200">
      <h2 className="!text-4xl md:!text-5xl font-bold text-center gradient-text">
        Welcome <span>Back!</span>
      </h2>

      <form
        className="mt-6 flex flex-col gap-5"
        onSubmit={handleSubmit}
        onChange={handleChange}
      >
        {errors?.message && <div className='email-existing-input'>
          <span style={{ color: "red" }}>{errors?.message}</span>
        </div>}
        <TextInput label="User Name" type="email" name='email' placeholder="hannah.green@test.com" />
        <TextInput label="Password" type="password" name='password' placeholder="Password123@" showEyeIcon />

        <div className="flex items-center justify-between mt-1">
          <div className="flex gap-2 items-center">
            <TextInput type="checkbox" name='remember_me' />
            <label className="block text-gray-700 text-sm">
              Remember me
            </label>
          </div>
          <Link
            to={{ pathname: `${basePath}${Paths.ForgotPassword}`, state: { email: "" } }}
            style={{ color: "#0054A6" }}
            className="text-sm hover:underline"
          >
            Forgot Password?
          </Link>
        </div>
        <div className="">
          <PrimaryButton type="submit">LOG IN</PrimaryButton>
        </div>
      </form>
    </div>
  );
}

function RegisterStep1({ formData, errors, handleChange }) {
  return (
    <div className="grid grid-cols-1 gap-4 items-center space-y-4">
      <TextInput
        label="Email*"
        type="email"
        placeholder="hannah.green@test.com"
        name="email"
        value={formData.email}
        onChange={handleChange}
        error={errors.email}
      />
      <TextInput
        label="Password*"
        type="password"
        placeholder="Password123@"
        name="password"
        value={formData.password}
        autoComplete="new-password"
        onChange={handleChange}
        error={errors.password}
        showEyeIcon
      />
      <TextInput
        label="Confirm Password*"
        type="password"
        placeholder="Password123@"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={handleChange}
        error={errors.confirmPassword}
        showEyeIcon
      />
    </div>
  );
}

function RegisterStep2({ formData, errors, handleChange }) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center  space-y-4">
        <TextInput
          label="First Name*"
          placeholder="Enter you first name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          error={errors.firstName}
        />
        <TextInput
          label="Last Name*"
          placeholder="Enter you Last name"
          name="lastName"
          className="!mt-0"
          value={formData.lastName}
          onChange={handleChange}
          error={errors.lastName}
        />

        <SelectInput
          label="Gender*"
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          options={["Female", "Male", "Non-binary", "Prefer not to respond"]}
          error={errors.gender}
        />
        <SelectInput
          label="Year of Birth*"
          name="yearOfBirth"
          value={formData.yearOfBirth}
          onChange={handleChange}
          options={Yearofbirthoption()}
          error={errors.yearOfBirth}
        />

        <SelectInput
          label="Race*"
          name="race"
          value={formData.race}
          onChange={handleChange}
          options={[
            "White",
            "Black or African American",
            "American Indian or Alaska Native",
            "Asian or Asian American",
            "Native Hawaiian or Other Pacific Islander",
            "Mixed Race",
            "Prefer not to respond",
          ]}
          error={errors.race}
        />
        <TextInput
          label="Zip Code*"
          placeholder="Zip Code"
          name="zipCode"
          value={formData.zipCode}
          onChange={handleChange}
          error={errors.zipCode}
        />
        <div className="md:col-span-2 !mt-0">
          <TextInput
            label="Purpose"
            placeholder="Enter purpose (optional)"
            name="purpose"
            value={formData.purpose || ""}
            onChange={handleChange}
            error={errors.purpose}
          />
        </div>
      </div>

      <div className="flex items-center gap-2 mt-4">
        <input type="checkbox" id="terms" name="terms" checked={formData.terms} onChange={handleChange} />
        <label htmlFor="terms" className="text-sm text-gray-700">
          I confirm I have read Censio's{" "}
          <Link to="/terms" target="_blank" className="text-[#0054A6] underline">
            T&amp;C
          </Link>
        </label>
      </div>
      {errors.terms && <p className="text-red-500 text-xs mt-1">{errors.terms}</p>}
    </>
  );
}

const Register = () => {
  const [step, setStep] = useState(1);
  const totalSteps = 2;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    gender: "",
    yearOfBirth: "",
    race: "",
    zipCode: "",
    terms: false,
    purpose: "",
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const emailExistErr = useSelector((state) => state.authReducer.emailExistErr)
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "firstName" || name === "lastName") {
      if (!/^[A-Za-z]*$/.test(value)) return;
    }
    if (name === "zipCode") {
      if (!/^\d*$/.test(value)) return;
    }
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const validateStep1 = () => {
    let newErrors = {};
    if (!formData.email.match(/^\S+@\S+\.\S+$/)) newErrors.email = "Enter a valid email";
    if (
      !formData.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/)
    )
      newErrors.password = "Password must be at least 8 chars, include uppercase, lowercase, number, and special char";
    if (formData.confirmPassword !== formData.password)
      newErrors.confirmPassword = "Passwords do not match";
    return newErrors;
  };

  const validateStep2 = () => {
    let newErrors = {};
    if (!formData.firstName) newErrors.firstName = "Required";
    if (!formData.lastName) newErrors.lastName = "Required";
    if (!formData.gender) newErrors.gender = "Required";
    if (!formData.yearOfBirth) newErrors.yearOfBirth = "Required";
    if (!formData.race) newErrors.race = "Required";
    if (!formData.zipCode) newErrors.zipCode = "Required";
    // if (!formData.bornInUS) newErrors.bornInUS = "Required";
    // if (!formData.workStatus) newErrors.workStatus = "Required";
    if (!formData.terms) newErrors.terms = "You must agree to T&C";
    return newErrors;
  };

  const nextStep = (e) => {
    e.preventDefault();
    const stepErrors = step === 1 ? validateStep1() : {};
    setErrors(stepErrors);
    if (Object.keys(stepErrors).length === 0) {
      authServices.emailExist(formData.email).then((data) => {
        if (data.status === 200) {
          dispatch(emailExist(false))
          setStep(step + 1)
        } else if (data.status === 422) {
          dispatch(emailExist(true))
          setStep(1)
        }
      })
    }
  };

  const prevStep = (e) => {
    e.preventDefault();
    setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const stepErrors = validateStep2();
    setErrors(stepErrors);
    if (Object.keys(stepErrors).length === 0) {
      var user = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        password: formData.password,
        gender: formData.gender,
        race: formData.race,
        zipcode: formData.zipCode,
        year_of_birth: formData.yearOfBirth,
        role: 'entrepreneur',
        purpose: formData.purpose
      };

      let form_data = new FormData();
      for (var key in user) {
        form_data.append(`user[${key}]`, user[key]);
      }

      authServices.userSignUp(form_data).then((data) => {
        axios.defaults.headers.common['Authorization'] = `${data.token}`;
        sessionStorage.setItem("ssoToken", data.token);
        const isCreighton = window.location.href.toLowerCase().includes("creighton");
        const basePath = isCreighton ? '/creighton' : '/entrepreneur';
        history.push(`${basePath}/introduction`)
      })

    }
  };

  return (
    <div className="bg-white shadow-[0px_1px_10px_2px_rgba(0,0,0,0.25)] rounded-2xl p-6 md:px-12 md:py-8 w-full flex flex-col gap-4 border border-gray-200">
      <h2 className="!text-4xl md:!text-5xl  font-bold text-center gradient-text m-0">Create New Account</h2>
      <ProgressStepper step={step} totalSteps={totalSteps} />
      <form className="space-y-2" onSubmit={handleSubmit}>
        {emailExistErr && <div className='email-existing-input'>
          <span style={{ color: "red" }}>{"An account with this email already exists."}</span>
        </div>}
        {step === 1 && <RegisterStep1 formData={formData} errors={errors} handleChange={handleChange} />}
        {step === 2 && <RegisterStep2 formData={formData} errors={errors} handleChange={handleChange} />}

        <div className="flex gap-4 -mt-4">
          {step > 1 && (
            <button
              type="button"
              onClick={prevStep}
              className="hover:bg-gray-200 w-full mt-6 new-font-display font-bold flex justify-center gap-3 items-center border border-[#0054A6] text-[#0054A6] px-8 py-4 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              PREVIOUS
            </button>
          )}
          {step < totalSteps ? (
            <PrimaryButton type="button" onClick={nextStep}>
              NEXT
            </PrimaryButton>
          ) : (
            <PrimaryButton type="submit">SUBMIT</PrimaryButton>
          )}
        </div>
      </form>
    </div>
  );
};

const AuthGateway = () => {
  const isCreighton = window.location.href.toLowerCase().includes("creighton");
  const contactPath = isCreighton ? Paths.CreightonContactUs : Paths.EntrepreneurContactUs;
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { codeHash } = params || {};

  const [step, setStep] = useState(1);

  const [showExtraFields, setShowExtraFields] = useState(false);

  const [codeSent, setCodeSent] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    purpose: "",
    verificationCode: "",
    accessCode: "",
    gender: "",
    yearOfBirth: "",
    race: "",
    zipCode: "",
    terms: false,
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [cooldown, setCooldown] = useState(0);
  const [isNewUserFlag, setIsNewUserFlag] = useState(false);

  const details = useSelector((state) => state.authReducer.details);

  const [directAccessCode, setDirectAccessCode] = useState("");

  useEffect(() => {
    if (codeHash) {
      let code = "";
      try {
        if (codeHash.includes('.') && codeHash.split('.').length === 3) {
          const payloadBase64 = codeHash.split('.')[1];
          const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
          const decodedPayload = JSON.parse(atob(base64));
          code = decodedPayload?.access_code || decodedPayload?.code || decodedPayload?.access_code_hash || "";
        }
        if (!code) {
          const base64Str = codeHash.replace(/-/g, '+').replace(/_/g, '/');
          code = atob(base64Str);
        }
      } catch (e) {
        code = codeHash;
      }

      if (code) {
        setDirectAccessCode(code);
        setFormData((prev) => ({ ...prev, accessCode: code }));
      }
    }
  }, [codeHash]);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  useEffect(() => {
    dispatch({ type: "RESET_ENTREPRENEURIAL_REPORT" });
  }, [dispatch]);

  const validateEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : (name === "email" ? value.trim().toLowerCase() : value);
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
    setErrors((prev) => ({ ...prev, [name]: "", message: "" }));
  };

  const handleCheckEmail = async (e) => {
    e.preventDefault();

    if (!formData.email?.trim() || !validateEmail(formData.email)) {
      setErrors({ email: "Enter a valid email address" });
      return;
    }

    setLoading(true);
    setErrors({});

    const targetAccessCode = directAccessCode || formData.accessCode;

    // If candidate accessed via direct login link, skip access code input step and directly trigger access code verification & OTP API
    if (targetAccessCode?.trim()) {
      try {
        const verifyRes = await dispatch(verifyAccessCode({
          access_code: targetAccessCode.trim(),
          email: formData.email.trim()
        }));

        if (verifyRes?.status === 200) {
          const otpRes = await dispatch(generateOtp({
            email: formData.email.trim(),
            access_code: targetAccessCode.trim(),
            is_creighton: isCreighton,
          }));

          const isSuccess = otpRes?.status === 200 || (otpRes?.data && !otpRes?.response);
          if (isSuccess) {
            setCodeSent(true);
            setStep(2);
            setCooldown(60);
          } else {
            const msg = otpRes?.response?.data?.message || otpRes?.response?.data?.error || otpRes?.message || "Failed to send verification code. Please try again.";
            setErrors({ message: msg });
          }
        } else {
          const msg = verifyRes?.data?.message || verifyRes?.response?.data?.message || verifyRes?.response?.data?.error || verifyRes?.message || "Invalid or expired access code link";
          setErrors({ email: msg });
        }
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || "Invalid access code link or server error. Please try again.";
        setErrors({ email: msg });
      } finally {
        setLoading(false);
      }
      return;
    }

    try {
      const res = await dispatch(isNewUser({ email: formData.email }));
      const bodyStatus = res?.data?.status;
      const httpStatus = res?.status;

      if (bodyStatus === 400 || httpStatus === 400) {
        // new user — show access code input
        setShowExtraFields(true);
      } else if (httpStatus === 200 || bodyStatus === 200) {
        const accessCodeStatus = res?.data?.data?.access_code_status;
        if (accessCodeStatus !== 'Active') {
          // existing user but code not active — show access code input
          setShowExtraFields(true);
        } else {
          // existing user and active — send OTP directly
          const otpRes = await dispatch(generateOtp({ email: formData.email, is_creighton: isCreighton }));
          const otpSuccess = otpRes?.status === 200 || (otpRes?.data && !otpRes?.response);
          if (otpSuccess) {
            setCodeSent(true);
            setCooldown(60);
            setStep(2);
          } else {
            const msg = otpRes?.response?.data?.message || otpRes?.response?.data?.error || otpRes?.message || "Failed to send verification code. Please try again.";
            setErrors({ message: msg });
          }
        }
      } else {
        const msg = res?.data?.message || res?.message || "Something went wrong. Please try again.";
        setErrors({ message: msg });
      }
    } catch (err) {
      const errStatus = err?.response?.status ?? err?.status;
      const errBodyStatus = err?.response?.data?.status;
      if (errStatus === 400 || errBodyStatus === 400) {
        setShowExtraFields(true);
      } else {
        const msg = err?.response?.data?.message || err?.message || "Something went wrong. Please try again.";
        setErrors({ message: msg });
      }
    } finally {
      setLoading(false);
    }
  };


  const handleSendAccessCode = async (e) => {
    e.preventDefault();
    if (!formData.accessCode?.trim()) {
      setErrors({ accessCode: "Access code is required" });
      return;
    }

    setLoading(true);
    setErrors({});
    try {
      const verifyRes = await dispatch(verifyAccessCode({
        access_code: formData.accessCode.trim(),
        email: formData.email
      }));

      if (verifyRes?.status === 200) {
        const res = await dispatch(generateOtp({
          email: formData.email,
          access_code: formData.accessCode.trim(),
          is_creighton: isCreighton,
        }));
        const isSuccess = res?.status === 200 || (res?.data && !res?.response);
        if (isSuccess) {
          setCodeSent(true);
          setStep(2);
          setCooldown(60);
        } else {
          const msg = res?.response?.data?.message || res?.response?.data?.error || res?.message || "Failed to send verification code. Please try again.";
          setErrors({ message: msg });
        }
      } else {
        const msg = verifyRes?.data?.message || verifyRes?.response?.data?.message || verifyRes?.response?.data?.error || verifyRes?.message || "Invalid or expired access code";
        setErrors({ accessCode: msg });
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Invalid access code or server error. Please try again.";
      setErrors({ accessCode: msg });
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (loading || cooldown > 0) return;
    setLoading(true);
    setErrors({});
    try {
      const res = await dispatch(generateOtp({ email: formData.email, is_creighton: isCreighton }));
      const isSuccess = res?.status === 200 || (res?.data && !res?.response);
      if (isSuccess) {
        setCooldown(60);
        setErrors({ verificationCode: "" });
      } else {
        const msg = res?.response?.data?.message || res?.response?.data?.error || res?.message || "Failed to resend code. Please try again.";
        setErrors({ message: msg });
      }
    } catch (err) {
      setErrors({ message: "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitAccessCode = async (e) => {
    e.preventDefault();
    if (!formData.verificationCode?.trim()) {
      setErrors({ verificationCode: "Verification code is required" });
      return;
    }
    setLoading(true);
    setErrors({});
    try {
      const trimmedOtp = formData.verificationCode.trim();
      const res = await dispatch(validateOtp({
        email: formData.email,
        verification_code: trimmedOtp,
      }));
      if (res?.status === 200) {
        if (res?.data?.message && res?.data?.status === 400) {
          setErrors({ verificationCode: res.data.message || "Invalid or expired verification code" });
        } else if (res?.data?.is_new === true) {
          axios.defaults.headers.common['Authorization'] = `${res?.data?.data?.token}`;
          sessionStorage.setItem("ssoToken", res?.data?.data?.token);
          const user = res?.data?.data?.user || {};
          setFormData(prev => ({
            ...prev,
            firstName: "",
            lastName: "",
            gender: "",
            yearOfBirth: "",
            race: "",
            zipCode: "",
            verificationCode: "",
            purpose: "",
            accessCode: ""
          }));
          setStep(3);
        } else {
          axios.defaults.headers.common['Authorization'] = `${res?.data?.data?.token}`;
          sessionStorage.setItem("ssoToken", res?.data?.data?.token);
          const { role, udc_user } = res?.data?.data?.user;
          const isCreighton = window.location.href.toLowerCase().includes("creighton");
          const basePath = isCreighton ? '/creighton' : '/entrepreneur';
          const redirecting_route = res?.data?.data?.user?.assessment_consent?.assessment_intro_consent
            ? `${basePath}/introduction`
            : `${basePath}/research-consent-form`;
          const routes = {
            super_admin: "/admin",
            udc_admin: "/org-dashboard",
            entrepreneur: redirecting_route,
            reporting_user: { pathname: "/repoting-page", state: { activeConstruct: "Resilience", subNav: "Resilience" } },
          };
          if (udc_user) history.push(Paths.upgradeDashboard);
          else if (role in routes) history.push(routes[role]);
          else history.push(Paths.upgradeDashboard);
        }
      } else {
        const msg = res?.response?.data?.message || res?.response?.data?.error || res?.message || "Invalid or expired verification code";
        setErrors({ verificationCode: msg });
      }
    } catch (err) {
      setErrors({ verificationCode: "Invalid code or server error. Please try again." });
    } finally {
      setLoading(false);
    }
  };



  const handleCompleteProfile = async (e) => {
    e.preventDefault();
    try {
      const requiredFields = ["firstName", "lastName", "gender", "yearOfBirth", "race", "zipCode"];
      const newErrors = {};
      if (!formData.terms) newErrors.terms = "You must agree to T&C";
      requiredFields.forEach((field) => { if (!formData[field]?.trim()) newErrors[field] = "This field is required"; });
      if (formData.zipCode && !/^\d{5,6}$/.test(formData.zipCode)) newErrors.zipCode = "Enter a valid zip code";
      if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

      var user = {
        first_name: formData.firstName, last_name: formData.lastName,
        gender: formData.gender, race: formData.race,
        zipcode: formData.zipCode, year_of_birth: formData.yearOfBirth, role: 'entrepreneur',
        purpose: formData.purpose,
      };
      let form_data = new FormData();
      for (var key in user) form_data.append(`user[${key}]`, user[key]);
      setErrors({});
      setLoading(true);
      axios.defaults.headers.common["Authorization"] = `${details.token}`;
      const token = details?.token
      const data = await authServices.userSignUpUpdate(form_data, details?.UUID, token);
      if (data?.status === 200) {
        sessionStorage.setItem("ssoToken", details.token);
        const isCreighton = window.location.href.toLowerCase().includes("creighton");
        const basePath = isCreighton ? '/creighton' : '/entrepreneur';
        history.push(`${basePath}/research-consent-form`);
      } else {
        axios.defaults.headers.common["Authorization"] = '';
        throw new Error("Invalid server response. Please try again.");
      }
    } catch (error) {
      setErrors({ message: error?.response?.data?.message || error?.message || "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <EntrepreneurTabs activeTab="registration" />
      <div className="premium-bg min-h-[calc(100vh-12rem)] flex items-center justify-center font-sans p-5 pb-10">
        <div className="flex flex-col items-center justify-center w-full max-w-3xl">

          {/* Auth Section */}
          <div className="w-full">
            <div className="bg-white shadow-[0_2px_10px_rgba(0,0,0,0.1)] rounded-2xl p-8 md:p-10 w-full border border-gray-200 flex flex-col gap-4">
              <h2 className="!text-3xl md:!text-3xl font-bold text-center gradient-text">
                {step === 1 ? "Access Your Assessment" : step === 2 ? "Enter Verification Code" : "Complete Your Profile"}
              </h2>

              {/* {isNewUser && (
              <div className="w-full">
                <ProgressStepper step={step} totalSteps={2} />
              </div>
            )} */}

              {errors.message && (
                <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-xl px-4 text-red-600 text-sm">
                  <svg className="shrink-0 mt-0.5" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
                  </svg>
                  <span>{errors.message}</span>
                </div>
              )}

              {/* STEP 1: Email entry + optional extra fields for new users */}
              {step === 1 && (
                <>
                  <div className="text-gray-600 text-l text-center mb-2">
                    Ready to begin? Enter your email below and we'll send you a unique verification code to access your assessment.
                  </div>

                  <form
                    onSubmit={showExtraFields ? handleSendAccessCode : handleCheckEmail}
                    className="flex flex-col gap-5"
                  >
                    <TextInput
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      error={errors.email}
                      disabled={showExtraFields || loading}
                    />

                    {showExtraFields && (
                      <>
                        <TextInput
                          label="Access Code"
                          name="accessCode"
                          type="text"
                          value={formData.accessCode}
                          onChange={handleChange}
                          placeholder="Enter your access code"
                          error={errors.accessCode}
                          disabled={loading}
                        />
                        <div className="text-gray-600 text-l text-center">
                          Don't have one? Contact the Censio administrator <Link to={contactPath} className="text-[#0054A6] hover:underline">here</Link> to request Individual or bulk access codes.
                        </div>
                      </>
                    )}

                    <PrimaryButton type="submit" disabled={loading}>
                      {loading ? "Please wait..." : showExtraFields ? "Validate Access Code" : "Continue"}
                    </PrimaryButton>
                  </form>

                  <div className="text-gray-600 text-l text-center">
                    Your information is used solely for assessment access and record-keeping purposes. We do not share your data with third parties.
                  </div>
                </>
              )}

              {/* STEP 2: Verification code entry */}
              {step === 2 && (
                <>
                  <div className="text-gray-600 text-l text-center">
                    We sent a verification code to <strong>{formData.email}</strong> Enter it below to continue.
                  </div>
                  <form onSubmit={handleSubmitAccessCode} className="flex flex-col gap-5">
                    <TextInput
                      label="Verification Code"
                      name="verificationCode"
                      id="verificationCode"
                      type="text"
                      inputMode="text"
                      autoComplete="one-time-code"
                      autoCapitalize="none"
                      autoCorrect="off"
                      spellCheck="false"
                      value={formData.verificationCode}
                      onChange={handleChange}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedData = (e.clipboardData || window.clipboardData)?.getData("text") || "";
                        const cleaned = pastedData.trim();
                        setFormData((prev) => ({ ...prev, verificationCode: cleaned }));
                        setErrors((prev) => ({ ...prev, verificationCode: "", message: "" }));
                      }}
                      placeholder="Enter your verification code"
                      error={errors.verificationCode}
                      disabled={loading}
                    />
                    <PrimaryButton type="submit" disabled={loading}>
                      {loading ? "Please wait..." : "Continue"}
                    </PrimaryButton>
                    <button
                      type="button"
                      onClick={() => { setStep(1); setCodeSent(false); setErrors({}); setShowExtraFields(false); }}
                      className="text-sm text-gray-500 hover:text-gray-700 text-center transition-colors"
                    >
                      ← Back
                    </button>
                  </form>
                  <div className="text-gray-600 text-l text-center">
                    Didn't receive your verification code? Check your spam folder or{" "}
                    <span
                      className={`text-blue-500 cursor-pointer hover:underline ${(loading || cooldown > 0) ? "opacity-50 pointer-events-none" : ""}`}
                      onClick={handleResendCode}
                    >
                      {cooldown > 0 ? `Resend in ${cooldown}s` : "request a new verification code"}
                    </span>.
                  </div>
                  {/* <div className='text-gray-600 text-l text-center'>
                    Bulk codes: To request a batch of access codes tailored to your group, please contact us at <a className="text-blue-500 cursor-pointer hover:underline" href="mailto:[EMAIL_ADDRESS]">admin.censio@gmail.com</a>
                  </div> */}
                </>
              )}

              {/* STEP 3: Complete Profile */}
              {step === 3 && (
                <form onSubmit={handleCompleteProfile}>
                  <RegisterStep2
                    formData={formData}
                    handleChange={handleChange}
                    errors={errors}
                  />
                  <div className="flex justify-end mt-4">
                    <PrimaryButton type="submit" disabled={loading}>
                      {loading ? "Saving..." : "Submit"}
                    </PrimaryButton>
                  </div>
                </form>
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );

};

export default AuthGateway;


export function ELForgotPassword() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const basePath = window.location.href.toLowerCase().includes("creighton") ? '/creighton' : '/entrepreneur';

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    let data = Object.fromEntries(formData)

    if (!data?.email.match(/^\S+@\S+\.\S+$/)) {
      setError("Enter a valid email address");
      return;
    }

    setLoading(true);
    authServices
      .userForgotPassword(data) // <-- update API call as per your backend
      .then((res) => {
        if (res.status === 200) {
          dispatch(showNotification(true, res.message, "success"))
          history.push(basePath)
        } else if (res.status === 401) {
          // if (res.message !== "Please enter a valid email") {
          // }
          dispatch(showNotification(true, res.message))
        }
        else {
          dispatch(showNotification(true, res.message))
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError("Unable to send reset link. Please try again.");
      });
  };

  return (
    <div className="premium-bg min-h-[calc(100dvh-5rem)] flex items-center justify-center font-sans p-5">
      <div className="bg-white shadow-[0px_1px_10px_2px_rgba(0,0,0,0.25)] rounded-2xl p-8 md:px-12 md:py-10 w-full max-w-2xl border border-gray-200">
        <h2 className="!text-3xl md:!text-4xl font-bold text-center gradient-text">
          Forgot <span>Password?</span>
        </h2>
        <p className="text-center text-gray-600 mt-2 mb-6">
          Enter your registered email address.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          {/* {successMessage && <p className="text-green-600 text-sm">{successMessage}</p>} */}
          <TextInput
            label="Email Address"
            type="email"
            name='email'
            placeholder="hannah.green@test.com"
            error={error}
          />

          <PrimaryButton type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </PrimaryButton>
        </form>
      </div>
    </div>
  );
}
